import React from "react";
import PropTypes from "prop-types";

import Header from "./Header";
import Recipients from "./Recipients";
import Content from "./Content";

const Attachments = ({attachments}) => (
  attachments ? (
    <div>
      Attachments:
      &nbsp;
      {attachments.map((attachment, index) => (
        <span
          key={index}
          style={{marginRight: 5}}
        >
          <a
            href={attachment.url}
            className="styled-link"
            target="_blank"
          >
            {attachment.name}
          </a>
          {index !== (attachments.length - 1) ? "," : ""}
        </span>
      ))}
    </div>
  ) : null
);

const Message = ({ searchString, data, destroyMessage, currentUserIsAdmin }) => (
  <div className="well shadowDepth1">
    <Header
      searchString={searchString}
      userId={data.user_id}
      created={data.created_at}
      userName={[data.user.last_name, data.user.first_name].join(", ")}
      messageType={data.message_type}
      destroyMessage={destroyMessage}
      message={data}
      currentUserIsAdmin={currentUserIsAdmin}
    />

    <br />

    <div className="row">
      <div className="col-md-12">
        <Recipients data={data.recipients_text} />

        <Content searchString={searchString} data={data} />
      </div>
    </div>

    <Attachments attachments={data.data_attachments}/>
  </div>
);

Message.propTypes = {
  searchString: PropTypes.string,
  data: PropTypes.object.isRequired
};

export default Message;
